/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAbbreviatedShow } from './AbbreviatedShow';

export interface TalentRequest {

    id?: string;

    /**
     * Name of the person
     */
    name?: string;

    /**
     * Title of the person
     */
    title?: string;

    /**
     * Bio for the person
     */
    bio?: string;

    /**
     * First portrait for person
     */
    thumbnail_portrait1?: string;

    /**
     * First portrait for person
     */
    thumbnail_portrait2?: string;

    /**
     * First landscape image for person
     */
    thumbnail_landscape1?: string;

    /**
     * First landscape image for person
     */
    landscape2?: string;

    /**
     * Facebook URL for this person
     */
    facebook_url?: string;

    /**
     * Twitter URL for this person
     */
    twitter_handle?: string;

    /**
     * Instagram URL for this person
     */
    instagram_handle?: string;

    /**
     * Snapchat handle for this person
     */
    snapchat_handle?: string;

    /**
     * The show for this talent (if available)
     */
    shows?: ApiAbbreviatedShow;

    /**
     * Primary role for this person
     */
    primary_role?: string;

}

@Model('Talent')
export class ApiTalent extends BaseModel implements TalentRequest {

    
    
    id: string;

    /**
     * Name of the person
     */
    
    
    name: string;

    /**
     * Title of the person
     */
    
    
    title: string;

    /**
     * Bio for the person
     */
    
    
    bio: string;

    /**
     * First portrait for person
     */
    
    
    thumbnail_portrait1: string;

    /**
     * First portrait for person
     */
    
    
    thumbnail_portrait2: string;

    /**
     * First landscape image for person
     */
    
    
    thumbnail_landscape1: string;

    /**
     * First landscape image for person
     */
    
    
    landscape2: string;

    /**
     * Facebook URL for this person
     */
    
    
    facebook_url: string;

    /**
     * Twitter URL for this person
     */
    
    
    twitter_handle: string;

    /**
     * Instagram URL for this person
     */
    
    
    instagram_handle: string;

    /**
     * Snapchat handle for this person
     */
    
    
    snapchat_handle: string;

    /**
     * The show for this talent (if available)
     */
    @Type('ApiAbbreviatedShow')
    @Expand()
    shows: ApiAbbreviatedShow;

    /**
     * Primary role for this person
     */
    
    
    primary_role: string;

}
